import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { trackEvent } from 'dibs-tracking';
import BarHeader from 'dibs-elements/dist/BarHeader';
import ModalBody from 'dibs-elements/dist/ModalBody';
import ModalContainer from 'dibs-elements/dist/ModalContainer';
import Button from 'dibs-elements/dist/Button/Primary';
import 'dibs-elements/dist/Button/buyer/Primary.css';
import style from './AutoModal.scss';

class AutoModal extends Component {
    constructor() {
        super();

        this.state = {
            modalOpened: true
        };

        this.closeModal = this.closeModal.bind(this);
        this.onClick = this.onClick.bind(this);
    }

    componentDidMount() {
        this.trackModalEvents({
            modalAction: 'displayed'
        });
    }

    closeModal() {
        this.setState({
            modalOpened: false
        });
    }

    trackModalEvents({ modalAction }) {
        const { tracking } = this.props;
        if (tracking) {
            const { category, action, label } = tracking;
            trackEvent({
                category,
                action: `${action} ${modalAction}`,
                label
            });
        }
    };

    onClick() {
        this.trackModalEvents({
            modalAction: 'clicked'
        });
        this.closeModal();
        this.props.onCtaClick();
    }

    render() {
        const { item, copy, children } = this.props;
        const { title, image } = item || {};

        return (
            <ModalContainer isOpen={this.state.modalOpened} modalPosition="center" onClose={this.closeModal}>
                <BarHeader title={copy.title} subtitle={copy.subtitle} />
                <ModalBody className={style.modalBody}>
                    {item &&
                        <div className={style.infoContainer}>
                            <img className={style.image} src={image} />
                            {title}
                        </div>
                    }
                    {children}
                    <Button
                        size="large"
                        className={style.button}
                        onClick={this.onClick}
                    >
                        {copy.cta}
                    </Button>
                    <a
                        className={style.link}
                        onClick={this.closeModal}
                    >
                        {copy.closeCta}
                    </a>
                </ModalBody>
            </ModalContainer>
        );
    }
};

AutoModal.propTypes = {
    copy: PropTypes.object.isRequired,
    onCtaClick: PropTypes.func.isRequired,
    item: PropTypes.object,
    tracking: PropTypes.object,
    children: PropTypes.node
};

export default AutoModal;



// WEBPACK FOOTER //
// ./src/abandonedCheckout/components/AutoModal.jsx